import React from 'react';
import ViewField from '../../library/view-field';
import InputWithLabel from '../../library/input-with-label';
import { EditData, ViewData } from '../../library/data-section';
import TextArea from '@/library/text-area';
import WysiwygEditor from '@/library/wysiwyg-editor';

type Props = {
  idx: number;
  sourceId?: string | number;
  placeId?: number;
  subtitle: { text: string };
  description: { text: string };
  richDescription?: { text: string };
  userEditingStrategy: 'update' | 'none';
  reset?: (id: string) => void;
  onChange?: (e: React.SyntheticEvent, key: string, id: string | number) => void;
};

const Editorial = (props: Props) => {
  const [editing, setEditing] = React.useState(false);
  const cancel = (id) => {
    if (props.reset) {
      props.reset(id);
    }
    setEditing(false);
  };

  const onSuccess = () => {
    setEditing(false);
  };

  const onChange = (e: React.SyntheticEvent, editorialType: string, placeId: string | number) => {
    if (props.onChange) {
      props.onChange(e, editorialType, placeId);
    }
  };

  return (
    <div data-cy="editorial" className="boone-listing__editorial__source" data-place-id={props.placeId}>
      <ViewData
        sectionTitle="Editorial"
        userEditingStrategy={props.userEditingStrategy}
        show={!editing}
        onClick={() => setEditing(true)}
      >
        <ViewField label="Subtitle" value={props.subtitle.text || ''} />
        <ViewField
          className="editor__textarea editor__textarea--view"
          label="Description"
          value={props.description.text || ''}
        />
        <div className="view-field">
          <label className="view-field__label">Rich Description</label>
          <div 
            className="view-field__value editor__textarea editor__textarea--view"
            dangerouslySetInnerHTML={{ __html: props.richDescription?.text || '' }}
          />
        </div>
      </ViewData>
      <EditData
        sectionTitle="Editorial"
        show={editing}
        params={{
          place_id: props.placeId,
          source_id: props.sourceId,
          listing: {
            description: props.description.text || null,
            subtitle: props.subtitle.text || null,
            rich_description: props.richDescription?.text || null,
          },
        }}
        onSuccess={() => onSuccess()}
        cancel={() => cancel(props.placeId)}
        userEditingStrategy={props.userEditingStrategy}
      >
        <InputWithLabel
          inputName={'place_' + props.placeId + '_subtitle'}
          label="Subtitle"
          value={props.subtitle.text}
          onChange={(e) => onChange(e, 'subtitle', props.placeId)}
        />
        <TextArea 
          label="Description"
          value={props.description.text} 
          onChange={(e) => onChange(e, 'description', props.placeId)}
        />
        <WysiwygEditor 
          label="Rich Description"
          value={props.richDescription?.text || ''} 
          onChange={(e) => onChange(e, 'rich_description', props.placeId)} 
          placeholder="Enter description..."
        />
      </EditData>
    </div>
  );
};

export default Editorial;
